import { render, staticRenderFns } from "./C2R.vue?vue&type=template&id=3642cdae"
import script from "./C2R.vue?vue&type=script&lang=js"
export * from "./C2R.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports